import * as type from '../../types';


export function changePasswordAction(data){
    return {
        type:type.CHANGE_PASSWORD_REQUEST,
        payload: data
    }
} 